import React          from 'react';
import { makeStyles } from '@material-ui/core/styles';
import colors         from '../../utils/colors';

//var clsx = require('classnames')

const useStyles = makeStyles(() => ({
    root: {
        cursor:      'pointer',
        marginLeft:  5,
        marginRight: 5,
    },
    string: {
        height:         70,
        width:          70,
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        fontSize:        30,
        borderRadius:   '0.5em'
    }
    
}))

type OperatorProps = {
    wideScreen:          boolean;
    string:              string;
    ind:                 number;
    selectedInputBox:    number;
    setSelectedInputBox: (val: number) => void;
    handleInputClick:    (val: number) => void;
}

const Operator: React.FC<OperatorProps> = ({
    wideScreen,
    string,
    ind,
    selectedInputBox,
    setSelectedInputBox,
    handleInputClick
}) => {

  const classes = useStyles();

  const mySize = React.useMemo(() => {
      return wideScreen ? 70 : 50
  },[wideScreen])

  const myColor = React.useMemo(() => {
     return ind === 1 || ind === 3 ? colors.darkGreen : colors.blue
  },[ind])


  return (

    <div 
       className = { classes.root }
       onClick   = { () => { handleInputClick(ind) }}
       style     = {{
           height: mySize,
           width:  mySize,
           color:  myColor
       }}
    >
        <div 
           className = { classes.string }
           style     = {{
            height:    mySize,
            width:     mySize,
            border:    `${ selectedInputBox === ind ? 3 : 1 }px solid ${ myColor }`,
            transform: `translate(0px, ${ selectedInputBox === ind ? -2 : 0 }px)`
        }}
        >
            { string }
        </div>
        
    </div>
  );
}

export default Operator;
